import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-present",
  "use": "icon-present-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" id=\"icon-present\">\n    <path fill=\"#fff\" fill-rule=\"nonzero\" d=\"M13 16v14H7a4 4 0 0 1-4-4V16h10zm4 0h10v10a4 4 0 0 1-4 4h-6V16zm-4-8v6H2.5A1.5 1.5 0 0 1 1 12.5v-3A1.5 1.5 0 0 1 2.5 8H13zm4 0h10.5A1.5 1.5 0 0 1 29 9.5v3a1.5 1.5 0 0 1-1.5 1.5H17V8zm-7-8h.004a3.541 3.541 0 0 1 3.494 2.964L14 6h-4a3 3 0 1 1 0-6zm10 0a3 3 0 0 1 0 6h-4l.502-3.036A3.541 3.541 0 0 1 19.996 0H20z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/present.svg
// module id = Nq0V
// module chunks = 1